module.exports = __webpack_public_path__ + "static/media/image2.4897d5dc.PNG";